import { useConnect, useDisconnect } from '@lair-finance/wagmi'
import { useCallback } from 'react'
import { dappPortalConnectorId } from '@/modules/game/shared/lib/sdk/dapp-portal.ts'
import { login } from '@/modules/game/features/dapp-portal-auth/api/login.ts'
import { getAuthStore } from '@/domains/auth/model/store.ts'
import { wagmiGetAccount } from '@/shared/lib/wagmi/api/wagmiGetAccount.ts'

export function useDappPortalLogin() {
  const { disconnectAsync } = useDisconnect()
  const { connectAsync, connectors } = useConnect()

  return useCallback(async () => {
    const connector = connectors.find(i => i.id === dappPortalConnectorId)
    if (!connector) return false

    await disconnectAsync()
    await connectAsync({ connector })

    const account = wagmiGetAccount()
    if (!account.address) return false

    await login(account.address)

    if (!getAuthStore().isLoggedIn) return false

    return true
  }, [disconnectAsync, connectAsync, connectors])
}
